import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { useParams } from "react-router-dom";

function PintaTerms() {
  const { lang } = useParams();

  const textByLang = {
    es: {
      title: "Términos y Condiciones de Pinta",
      updated: "Última actualización: 4 de abril de 2026",
      sections: [
        {
          variant: "h5",
          heading: "1. Términos generales",
        },
        {
          variant: "body1",
          content:
            "Al descargar, acceder o usar Pinta – Coloring Book (\"Pinta\", \"nosotros\", \"nuestro\"), aceptas estar sujeto a estos Términos y Condiciones.\n\nSi no estás de acuerdo, no uses la aplicación.\n\nNos reservamos el derecho de actualizar estos Términos en cualquier momento. El uso continuo de la aplicación después de los cambios constituye aceptación de los Términos actualizados.",
        },
        {
          variant: "h5",
          heading: "2. Licencia",
        },
        {
          variant: "body1",
          content:
            "Pinta te otorga una licencia revocable, no exclusiva, intransferible y limitada para usar la aplicación con fines personales y no comerciales, de acuerdo con estos Términos.",
        },
        {
          variant: "h5",
          heading: "3. Suscripciones y precios",
        },
        {
          variant: "h6",
          heading: "3.1 Acceso por suscripción",
        },
        {
          variant: "body1",
          content: "Algunas funciones de Pinta están disponibles mediante suscripciones de pago.",
        },
        {
          variant: "h6",
          heading: "3.2 Garantía de precio",
        },
        {
          variant: "body1",
          content:
            "El precio al que te suscribes se mantiene mientras tu suscripción esté activa.\n\nNunca aumentaremos el precio de una suscripción activa. Sin embargo, si cancelas o expira la suscripción, cualquier suscripción futura podrá ofrecerse a un precio diferente.",
        },
        {
          variant: "h6",
          heading: "3.3 Prueba gratuita",
        },
        {
          variant: "body1",
          content:
            "Si se ofrece una prueba gratuita, se convertirá automáticamente en una suscripción paga a menos que se cancele antes del final del periodo de prueba.",
        },
        {
          variant: "h5",
          heading: "4. Funciones gratis vs premium",
        },
        {
          variant: "body1",
          content: "Pinta ofrece tanto funciones gratuitas como premium.",
        },
        {
          variant: "h6",
          heading: "4.1 Limitaciones del acceso gratuito",
        },
        {
          variant: "body1",
          content:
            "Ciertos contenidos y funcionalidades solo están disponibles para usuarios premium.\n\nLos usuarios gratuitos pueden experimentar acceso limitado, incluyendo pero no limitándose a:\n• Acceso restringido a ciertas plantillas, paquetes de contenido o herramientas\n• Uso limitado de funciones avanzadas o efectos\n• Restricciones en la edición o interacción con cierto contenido",
        },
        {
          variant: "h6",
          heading: "4.2 Contenido y funciones premium",
        },
        {
          variant: "body1",
          content:
            "Algunas plantillas, herramientas o funciones se consideran contenido premium.\n\nEl acceso y uso completo de este contenido puede requerir una suscripción activa.",
        },
        {
          variant: "h5",
          heading: "5. Contenido del usuario",
        },
        {
          variant: "body1",
          content:
            "Puedes importar imágenes o crear contenido dentro de la aplicación (\"Contenido del usuario\").\n\nConservas la propiedad de tu contenido. Sin embargo:\n• Eres responsable de asegurarte de tener los derechos para usar cualquier contenido importado\n• Ciertas funciones relacionadas con importar o editar contenido pueden estar restringidas al acceso premium",
        },
        {
          variant: "h5",
          heading: "6. Restricciones",
        },
        {
          variant: "body1",
          content:
            "Aceptas no:\n• Hacer ingeniería inversa, decompilar o intentar extraer el código fuente de la aplicación\n• Usar la aplicación para fines ilegales\n• Distribuir, revender o explotar comercialmente la aplicación\n• Eludir o intentar eludir restricciones de funciones o controles de acceso",
        },
        {
          variant: "h5",
          heading: "7. Disponibilidad y cambios",
        },
        {
          variant: "body1",
          content:
            "Podemos:\n• Modificar, suspender o descontinuar funciones en cualquier momento\n• Agregar o eliminar contenido o funcionalidades\n• Actualizar precios para nuevas suscripciones\n\nNo somos responsables de ninguna modificación o descontinuación del servicio.",
        },
        {
          variant: "h5",
          heading: "8. Renuncia de responsabilidad",
        },
        {
          variant: "body1",
          content:
            "La aplicación se proporciona \"tal cual\" sin garantías de ningún tipo.\n\nNo garantizamos que:\n• La aplicación esté libre de errores\n• La aplicación sea ininterrumpida\n• Cualquier contenido permanezca siempre disponible",
        },
        {
          variant: "h5",
          heading: "9. Limitación de responsabilidad",
        },
        {
          variant: "body1",
          content:
            "En la máxima medida permitida por la ley, Pinta no será responsable de:\n• Cualquier daño indirecto, incidental o consecuente\n• Pérdida de datos, contenido o ganancias",
        },
        {
          variant: "h5",
          heading: "10. Terminación",
        },
        {
          variant: "body1",
          content:
            "Nos reservamos el derecho de suspender o terminar el acceso a la aplicación si se violan estos Términos.",
        },
        {
          variant: "h5",
          heading: "11. Contacto",
        },
        {
          variant: "body1",
          content:
            "Si tienes preguntas, contáctanos en:\nsupport@pintative.com",
        },
      ],
    },
    en: {
      title: "Pinta Terms & Conditions",
      updated: "Last updated: April 4, 2026",
      sections: [
        {
          variant: "h5",
          heading: "1. General Terms",
        },
        {
          variant: "body1",
          content:
            "By downloading, accessing, or using Pinta – Coloring Book (\"Pinta\", \"we\", \"us\", or \"our\"), you agree to be bound by these Terms & Conditions.\n\nIf you do not agree, please do not use the application.\n\nWe reserve the right to update these Terms at any time. Continued use of the app after changes constitutes acceptance of the updated Terms.",
        },
        {
          variant: "h5",
          heading: "2. License",
        },
        {
          variant: "body1",
          content:
            "Pinta grants you a revocable, non-exclusive, non-transferable, limited license to use the app for personal, non-commercial purposes, in accordance with these Terms.",
        },
        {
          variant: "h5",
          heading: "3. Subscriptions & Pricing",
        },
        {
          variant: "h6",
          heading: "3.1 Subscription Access",
        },
        {
          variant: "body1",
          content: "Some features of Pinta are available through paid subscriptions.",
        },
        {
          variant: "h6",
          heading: "3.2 Price Guarantee",
        },
        {
          variant: "body1",
          content:
            "The price you subscribe to is locked for as long as your subscription remains active.\n\nWe will never increase the price of an active subscription. However, if your subscription is cancelled or expires, any future subscription may be offered at a different price.",
        },
        {
          variant: "h6",
          heading: "3.3 Free Trial",
        },
        {
          variant: "body1",
          content:
            "If a free trial is offered, it will automatically convert into a paid subscription unless cancelled before the trial period ends.",
        },
        {
          variant: "h5",
          heading: "4. Free vs Premium Features",
        },
        {
          variant: "body1",
          content: "Pinta offers both free and premium features.",
        },
        {
          variant: "h6",
          heading: "4.1 Free Access Limitations",
        },
        {
          variant: "body1",
          content:
            "Certain content and functionalities are only available to premium users.\n\nFree users may experience limited access, including but not limited to:\n• Restricted access to certain templates, content packs, or tools\n• Limited use of advanced features or effects\n• Restrictions on editing or interacting with certain content",
        },
        {
          variant: "h6",
          heading: "4.2 Premium Content & Features",
        },
        {
          variant: "body1",
          content:
            "Some templates, tools, or features are designated as premium content.\n\nAccess to and full use of such content may require an active subscription.",
        },
        {
          variant: "h5",
          heading: "5. User Content",
        },
        {
          variant: "body1",
          content:
            "You may import images or create content within the app (\"User Content\").\n\nYou retain ownership of your content. However:\n• You are responsible for ensuring you have the rights to use any imported content\n• Certain features related to importing or editing content may be restricted to premium access",
        },
        {
          variant: "h5",
          heading: "6. Restrictions",
        },
        {
          variant: "body1",
          content:
            "You agree not to:\n• Reverse engineer, decompile, or attempt to extract the source code of the app\n• Use the app for unlawful purposes\n• Distribute, resell, or exploit the app commercially\n• Circumvent or attempt to bypass feature restrictions or access controls",
        },
        {
          variant: "h5",
          heading: "7. Availability & Changes",
        },
        {
          variant: "body1",
          content:
            "We may:\n• Modify, suspend, or discontinue features at any time\n• Add or remove content or functionality\n• Update pricing for new subscriptions\n\nWe are not liable for any modification or discontinuation of the service.",
        },
        {
          variant: "h5",
          heading: "8. Disclaimer",
        },
        {
          variant: "body1",
          content:
            "The app is provided \"as is\" without warranties of any kind.\n\nWe do not guarantee that:\n• The app will be error-free\n• The app will be uninterrupted\n• Any content will always remain available",
        },
        {
          variant: "h5",
          heading: "9. Limitation of Liability",
        },
        {
          variant: "body1",
          content:
            "To the maximum extent permitted by law, Pinta shall not be liable for:\n• Any indirect, incidental, or consequential damages\n• Loss of data, content, or profits",
        },
        {
          variant: "h5",
          heading: "10. Termination",
        },
        {
          variant: "body1",
          content:
            "We reserve the right to suspend or terminate access to the app if these Terms are violated.",
        },
        {
          variant: "h5",
          heading: "11. Contact",
        },
        {
          variant: "body1",
          content:
            "If you have any questions, contact us at:\nsupport@pintative.com",
        },
      ],
    },
    fr: {
      title: "Conditions générales de Pinta",
      updated: "Dernière mise à jour : 4 avril 2026",
      sections: [
        {
          variant: "h5",
          heading: "1. Conditions générales",
        },
        {
          variant: "body1",
          content:
            "En téléchargeant, en accédant ou en utilisant Pinta – Coloring Book (\"Pinta\", \"nous\", \"notre\"), vous acceptez d'être lié par ces Conditions générales.\n\nSi vous n'êtes pas d'accord, veuillez ne pas utiliser l'application.\n\nNous nous réservons le droit de mettre à jour ces Conditions à tout moment. L'utilisation continue de l'application après les modifications constitue une acceptation des Conditions mises à jour.",
        },
        {
          variant: "h5",
          heading: "2. Licence",
        },
        {
          variant: "body1",
          content:
            "Pinta vous accorde une licence révocable, non exclusive, non transférable et limitée pour utiliser l'application à des fins personnelles et non commerciales, conformément à ces Conditions.",
        },
        {
          variant: "h5",
          heading: "3. Abonnements et prix",
        },
        {
          variant: "h6",
          heading: "3.1 Accès par abonnement",
        },
        {
          variant: "body1",
          content: "Certaines fonctionnalités de Pinta sont disponibles via des abonnements payants.",
        },
        {
          variant: "h6",
          heading: "3.2 Garantie de prix",
        },
        {
          variant: "body1",
          content:
            "Le prix auquel vous vous abonnez est maintenu tant que votre abonnement est actif.\n\nNous n'augmenterons jamais le prix d'un abonnement actif. Cependant, si votre abonnement est annulé ou expire, tout abonnement futur pourra être proposé à un prix différent.",
        },
        {
          variant: "h6",
          heading: "3.3 Essai gratuit",
        },
        {
          variant: "body1",
          content:
            "Si une période d'essai gratuite est proposée, elle se convertira automatiquement en un abonnement payant à moins d'être annulée avant la fin de la période d'essai.",
        },
        {
          variant: "h5",
          heading: "4. Fonctionnalités gratuites vs premium",
        },
        {
          variant: "body1",
          content: "Pinta propose à la fois des fonctionnalités gratuites et premium.",
        },
        {
          variant: "h6",
          heading: "4.1 Limitations de l'accès gratuit",
        },
        {
          variant: "body1",
          content:
            "Certain contenu et certaines fonctionnalités sont disponibles uniquement pour les utilisateurs premium.\n\nLes utilisateurs gratuits peuvent avoir un accès limité, notamment mais sans s'y limiter :\n• Accès restreint à certains modèles, packs de contenu ou outils\n• Utilisation limitée des fonctionnalités avancées ou des effets\n• Restrictions sur l'édition ou l'interaction avec certains contenus",
        },
        {
          variant: "h6",
          heading: "4.2 Contenu et fonctionnalités premium",
        },
        {
          variant: "body1",
          content:
            "Certaines maquettes, outils ou fonctionnalités sont désignés comme du contenu premium.\n\nL'accès et l'utilisation complète de ce contenu peuvent nécessiter un abonnement actif.",
        },
        {
          variant: "h5",
          heading: "5. Contenu de l'utilisateur",
        },
        {
          variant: "body1",
          content:
            "Vous pouvez importer des images ou créer du contenu dans l'application (\"Contenu de l'utilisateur\").\n\nVous conservez la propriété de votre contenu. Cependant :\n• Vous êtes responsable de vous assurer que vous avez les droits d'utiliser tout contenu importé\n• Certaines fonctionnalités liées à l'importation ou à l'édition de contenu peuvent être réservées aux abonnés premium",
        },
        {
          variant: "h5",
          heading: "6. Restrictions",
        },
        {
          variant: "body1",
          content:
            "Vous acceptez de ne pas :\n• Décompiler, rétroconcevoir ou tenter d'extraire le code source de l'application\n• Utiliser l'application à des fins illégales\n• Distribuer, revendre ou exploiter commercialement l'application\n• Contourner ou tenter de contourner les restrictions de fonctionnalités ou les contrôles d'accès",
        },
        {
          variant: "h5",
          heading: "7. Disponibilité et modifications",
        },
        {
          variant: "body1",
          content:
            "Nous pouvons :\n• Modifier, suspendre ou interrompre des fonctionnalités à tout moment\n• Ajouter ou supprimer du contenu ou des fonctionnalités\n• Mettre à jour les prix pour les nouveaux abonnements\n\nNous ne sommes pas responsables de toute modification ou interruption du service.",
        },
        {
          variant: "h5",
          heading: "8. Avis de non-responsabilité",
        },
        {
          variant: "body1",
          content:
            "L'application est fournie \"telle quelle\" sans garanties de quelque nature que ce soit.\n\nNous ne garantissons pas que :\n• L'application soit exempte d'erreurs\n• L'application soit ininterrompue\n• Un contenu reste toujours disponible",
        },
        {
          variant: "h5",
          heading: "9. Limitation de responsabilité",
        },
        {
          variant: "body1",
          content:
            "Dans la mesure maximale permise par la loi, Pinta ne sera pas responsable de :\n• Tout dommage indirect, accessoire ou conséquent\n• Perte de données, de contenu ou de bénéfices",
        },
        {
          variant: "h5",
          heading: "10. Résiliation",
        },
        {
          variant: "body1",
          content:
            "Nous nous réservons le droit de suspendre ou de résilier l'accès à l'application si ces Conditions sont violées.",
        },
        {
          variant: "h5",
          heading: "11. Contact",
        },
        {
          variant: "body1",
          content:
            "Si vous avez des questions, contactez-nous à :\nsupport@pintative.com",
        },
      ],
    },
    de: {
      title: "Pinta Allgemeine Geschäftsbedingungen",
      updated: "Zuletzt aktualisiert: 4. April 2026",
      sections: [
        {
          variant: "h5",
          heading: "1. Allgemeine Bedingungen",
        },
        {
          variant: "body1",
          content:
            "Durch das Herunterladen, Zugreifen oder Verwenden von Pinta – Coloring Book (\"Pinta\", \"wir\", \"uns\" oder \"unser\") erklären Sie sich mit diesen Allgemeinen Geschäftsbedingungen einverstanden.\n\nWenn Sie nicht einverstanden sind, verwenden Sie die Anwendung bitte nicht.\n\nWir behalten uns das Recht vor, diese Bedingungen jederzeit zu aktualisieren. Die fortgesetzte Nutzung der App nach Änderungen gilt als Annahme der aktualisierten Bedingungen.",
        },
        {
          variant: "h5",
          heading: "2. Lizenz",
        },
        {
          variant: "body1",
          content:
            "Pinta gewährt Ihnen eine widerrufliche, nicht ausschließliche, nicht übertragbare, eingeschränkte Lizenz zur Nutzung der App für persönliche, nicht kommerzielle Zwecke gemäß diesen Bedingungen.",
        },
        {
          variant: "h5",
          heading: "3. Abonnements & Preise",
        },
        {
          variant: "h6",
          heading: "3.1 Abonnementzugang",
        },
        {
          variant: "body1",
          content: "Einige Funktionen von Pinta sind durch kostenpflichtige Abonnements verfügbar.",
        },
        {
          variant: "h6",
          heading: "3.2 Preisgarantie",
        },
        {
          variant: "body1",
          content:
            "Der Preis, für den Sie sich abonnieren, bleibt so lange gesperrt, wie Ihr Abonnement aktiv ist.\n\nWir werden den Preis eines aktiven Abonnements niemals erhöhen. Wenn Ihr Abonnement jedoch gekündigt wird oder ausläuft, kann ein zukünftiges Abonnement zu einem anderen Preis angeboten werden.",
        },
        {
          variant: "h6",
          heading: "3.3 Kostenloser Test",
        },
        {
          variant: "body1",
          content:
            "Wenn ein kostenloser Test angeboten wird, wird er automatisch in ein kostenpflichtiges Abonnement umgewandelt, es sei denn, er wird vor Ende des Testzeitraums gekündigt.",
        },
        {
          variant: "h5",
          heading: "4. Kostenlose vs Premium-Funktionen",
        },
        {
          variant: "body1",
          content: "Pinta bietet sowohl kostenlose als auch Premium-Funktionen.",
        },
        {
          variant: "h6",
          heading: "4.1 Beschränkungen des kostenlosen Zugangs",
        },
        {
          variant: "body1",
          content:
            "Bestimmte Inhalte und Funktionen sind nur für Premium-Benutzer verfügbar.\n\nKostenlose Benutzer können eingeschränkten Zugriff haben, einschließlich aber nicht beschränkt auf:\n• Eingeschränkter Zugriff auf bestimmte Vorlagen, Inhalts-Pakete oder Tools\n• Begrenzte Nutzung von erweiterten Funktionen oder Effekten\n• Einschränkungen beim Bearbeiten oder Interagieren mit bestimmten Inhalten",
        },
        {
          variant: "h6",
          heading: "4.2 Premium-Inhalte & Funktionen",
        },
        {
          variant: "body1",
          content:
            "Einige Vorlagen, Tools oder Funktionen sind als Premium-Inhalte gekennzeichnet.\n\nDer Zugriff auf diese Inhalte und deren vollständige Nutzung kann ein aktives Abonnement erfordern.",
        },
        {
          variant: "h5",
          heading: "5. Benutzerinhalte",
        },
        {
          variant: "body1",
          content:
            "Sie können Bilder importieren oder Inhalte in der App erstellen (\"Benutzerinhalte\").\n\nSie behalten das Eigentum an Ihren Inhalten. Allerdings:\n• Sie sind dafür verantwortlich sicherzustellen, dass Sie die Rechte zur Nutzung importierter Inhalte haben\n• Bestimmte Funktionen zum Importieren oder Bearbeiten von Inhalten können auf Premium-Zugang beschränkt sein",
        },
        {
          variant: "h5",
          heading: "6. Einschränkungen",
        },
        {
          variant: "body1",
          content:
            "Sie erklären sich damit einverstanden, nicht zu:\n• Reverse Engineering, dekompilieren oder versuchen, den Quellcode der App zu extrahieren\n• Die App für rechtswidrige Zwecke zu verwenden\n• Die App kommerziell zu verteilen, weiterzuverkaufen oder auszubeuten\n• Funktionsbeschränkungen oder Zugangskontrollen zu umgehen oder zu versuchen, sie zu umgehen",
        },
        {
          variant: "h5",
          heading: "7. Verfügbarkeit & Änderungen",
        },
        {
          variant: "body1",
          content:
            "Wir können:\n• Funktionen jederzeit ändern, aussetzen oder einstellen\n• Inhalte oder Funktionen hinzufügen oder entfernen\n• Preise für neue Abonnements aktualisieren\n\nWir haften nicht für Änderungen oder die Einstellung des Dienstes.",
        },
        {
          variant: "h5",
          heading: "8. Haftungsausschluss",
        },
        {
          variant: "body1",
          content:
            "Die App wird \"wie besehen\" ohne jegliche Garantien bereitgestellt.\n\nWir garantieren nicht, dass:\n• Die App fehlerfrei ist\n• Die App ununterbrochen läuft\n• Inhalte immer verfügbar bleiben",
        },
        {
          variant: "h5",
          heading: "9. Haftungsbeschränkung",
        },
        {
          variant: "body1",
          content:
            "Soweit gesetzlich zulässig, haftet Pinta nicht für:\n• Indirekte, zufällige oder Folgeschäden\n• Verluste von Daten, Inhalten oder Gewinnen",
        },
        {
          variant: "h5",
          heading: "10. Beendigung",
        },
        {
          variant: "body1",
          content:
            "Wir behalten uns das Recht vor, den Zugang zur App zu sperren oder zu beenden, wenn diese Bedingungen verletzt werden.",
        },
        {
          variant: "h5",
          heading: "11. Kontakt",
        },
        {
          variant: "body1",
          content:
            "Wenn Sie Fragen haben, kontaktieren Sie uns unter:\nsupport@pintative.com",
        },
      ],
    },
    it: {
      title: "Termini e Condizioni di Pinta",
      updated: "Ultimo aggiornamento: 4 aprile 2026",
      sections: [
        {
          variant: "h5",
          heading: "1. Termini generali",
        },
        {
          variant: "body1",
          content:
            "Scaricando, accedendo o utilizzando Pinta – Coloring Book (\"Pinta\", \"noi\", \"nostro\"), accetti di essere vincolato da questi Termini e Condizioni.\n\nSe non sei d'accordo, non usare l'applicazione.\n\nCi riserviamo il diritto di aggiornare questi Termini in qualsiasi momento. L'uso continuato dell'app dopo le modifiche costituisce accettazione dei Termini aggiornati.",
        },
        {
          variant: "h5",
          heading: "2. Licenza",
        },
        {
          variant: "body1",
          content:
            "Pinta ti concede una licenza revocabile, non esclusiva, non trasferibile e limitata per utilizzare l'app per scopi personali e non commerciali, in conformità con questi Termini.",
        },
        {
          variant: "h5",
          heading: "3. Abbonamenti e prezzi",
        },
        {
          variant: "h6",
          heading: "3.1 Accesso in abbonamento",
        },
        {
          variant: "body1",
          content: "Alcune funzioni di Pinta sono disponibili tramite abbonamenti a pagamento.",
        },
        {
          variant: "h6",
          heading: "3.2 Garanzia del prezzo",
        },
        {
          variant: "body1",
          content:
            "Il prezzo a cui ti abboni è bloccato finché il tuo abbonamento rimane attivo.\n\nNon aumenteremo mai il prezzo di un abbonamento attivo. Tuttavia, se il tuo abbonamento viene annullato o scade, qualsiasi abbonamento futuro potrà essere offerto a un prezzo diverso.",
        },
        {
          variant: "h6",
          heading: "3.3 Prova gratuita",
        },
        {
          variant: "body1",
          content:
            "Se viene offerta una prova gratuita, si convertirà automaticamente in un abbonamento a pagamento a meno che non venga annullata prima della fine del periodo di prova.",
        },
        {
          variant: "h5",
          heading: "4. Funzionalità gratuite vs premium",
        },
        {
          variant: "body1",
          content: "Pinta offre sia funzionalità gratuite che premium.",
        },
        {
          variant: "h6",
          heading: "4.1 Limitazioni dell'accesso gratuito",
        },
        {
          variant: "body1",
          content:
            "Alcuni contenuti e funzionalità sono disponibili solo per gli utenti premium.\n\nGli utenti gratuiti possono avere accesso limitato, incluso ma non limitato a:\n• Accesso ristretto a determinati modelli, pacchetti di contenuti o strumenti\n• Uso limitato di funzionalità avanzate o effetti\n• Restrizioni sulla modifica o l'interazione con determinati contenuti",
        },
        {
          variant: "h6",
          heading: "4.2 Contenuti e funzionalità premium",
        },
        {
          variant: "body1",
          content:
            "Alcuni modelli, strumenti o funzionalità sono designati come contenuti premium.\n\nL'accesso e l'uso completo di tali contenuti possono richiedere un abbonamento attivo.",
        },
        {
          variant: "h5",
          heading: "5. Contenuti dell'utente",
        },
        {
          variant: "body1",
          content:
            "Puoi importare immagini o creare contenuti all'interno dell'app (\"Contenuti dell'utente\").\n\nMantieni la proprietà dei tuoi contenuti. Tuttavia:\n• Sei responsabile di assicurarti di avere i diritti per utilizzare qualsiasi contenuto importato\n• Alcune funzionalità relative all'importazione o modifica dei contenuti possono essere limitate all'accesso premium",
        },
        {
          variant: "h5",
          heading: "6. Restrizioni",
        },
        {
          variant: "body1",
          content:
            "Accetti di non:\n• Fare ingegneria inversa, decompilare o tentare di estrarre il codice sorgente dell'app\n• Utilizzare l'app per scopi illegali\n• Distribuire, rivendere o sfruttare commercialmente l'app\n• Circumventare o tentare di eludere le restrizioni delle funzionalità o i controlli di accesso",
        },
        {
          variant: "h5",
          heading: "7. Disponibilità e modifiche",
        },
        {
          variant: "body1",
          content:
            "Possiamo:\n• Modificare, sospendere o interrompere le funzionalità in qualsiasi momento\n• Aggiungere o rimuovere contenuti o funzionalità\n• Aggiornare i prezzi per i nuovi abbonamenti\n\nNon siamo responsabili per eventuali modifiche o interruzioni del servizio.",
        },
        {
          variant: "h5",
          heading: "8. Esclusione di responsabilità",
        },
        {
          variant: "body1",
          content:
            "L'app viene fornita \"così com'è\" senza alcuna garanzia.\n\nNon garantiamo che:\n• L'app sia priva di errori\n• L'app sia ininterrotta\n• I contenuti rimangano sempre disponibili",
        },
        {
          variant: "h5",
          heading: "9. Limitazione di responsabilità",
        },
        {
          variant: "body1",
          content:
            "Nella massima misura consentita dalla legge, Pinta non sarà responsabile per:\n• Danni indiretti, incidentali o consequenziali\n• Perdita di dati, contenuti o profitti",
        },
        {
          variant: "h5",
          heading: "10. Terminazione",
        },
        {
          variant: "body1",
          content:
            "Ci riserviamo il diritto di sospendere o terminare l'accesso all'app se questi Termini vengono violati.",
        },
        {
          variant: "h5",
          heading: "11. Contatto",
        },
        {
          variant: "body1",
          content:
            "Se hai domande, contattaci a:\nsupport@pintative.com",
        },
      ],
    },
  };

  const t = textByLang[lang] || textByLang.en;

  return (
    <Box sx={{ maxWidth: "800px", mx: "auto", p: 3 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" mb={3}>
          {t.title}
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          {t.updated}
        </Typography>

        {t.sections.map((section, index) => (
          <React.Fragment key={index}>
            <Typography
              variant={section.variant}
              sx={{
                fontWeight: section.variant === "body1" ? "normal" : "bold",
                mt: section.variant === "body1" && index !== 0 ? 0 : 3,
                mb: section.mb || 1,
              }}
            >
              {section.heading}
            </Typography>
            {section.content && (
              <Typography
                variant="body1"
                sx={{ mb: 2, whiteSpace: "pre-line" }}
              >
                {section.content}
              </Typography>
            )}
          </React.Fragment>
        ))}
      </Paper>
    </Box>
  );
}

export default PintaTerms;
